import { reactive } from 'vue'

const STORAGE_KEY = 'themeMode'
// 'light' | 'dark' | 'system'
const VALID = ['light', 'dark', 'system']

const media = window.matchMedia('(prefers-color-scheme: dark)')

function systemPrefersDark() {
  return media.matches
}

function resolve(mode) {
  return mode === 'system' ? (systemPrefersDark() ? 'dark' : 'light') : mode
}

function apply(mode) {
  document.documentElement.classList.toggle('dark', resolve(mode) === 'dark')
}

const stored = localStorage.getItem(STORAGE_KEY)
const initial = VALID.includes(stored) ? stored : 'system'

export const themeState = reactive({
  mode: initial,
  set(mode) {
    if (!VALID.includes(mode)) return
    this.mode = mode
    localStorage.setItem(STORAGE_KEY, mode)
    apply(mode)
  },
})

// Apply on load and react to OS changes while in 'system' mode.
apply(themeState.mode)
media.addEventListener('change', () => {
  if (themeState.mode === 'system') apply('system')
})
